// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as SocialFacebookComponent} from './SocialFacebook.svg';

import Icon, { TIconProps } from '../Icon';

export const IconSocialFacebook = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <SocialFacebookComponent/>
  </Icon>
));
